import { FSH5Http } from '@fs/http'
import h5InitInterceptors from './interceptors/h5Index'
import axios from 'axios'

const { VUE_APP_ENV } = process.env

const http = new FSH5Http({ adapter: axios })

http?.registerDecryptFunction({ VUE_APP_ENV: VUE_APP_ENV })

h5InitInterceptors(http)

export default http
